import { log } from "~features/seated-reservation/helpers/stateLogger";
import { getState, setState } from "../index";

interface ActionProps {
  seatLabels?: string[];
}

export const unsetSeats = (payload: ActionProps = {}) => {
  log("unsetSeats");

  if (payload.seatLabels) {
    const seats = getState().seats?.filter(
      (seat) => !payload.seatLabels.includes(seat.label)
    );
    return setState({ seats, selectFailed: false });
  } else {
    return setState({
      seats: [],
      selectFailed: false,
    });
  }
};
